module.exports = __webpack_public_path__ + "static/media/badge-price-empire.bb87bf69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/newDropshipperApp/images/badge-price-empire.svg
// module id = 2166
// module chunks = 0